import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { uploadFile, uploadFileMultipleInput } from "../../utils/Common";
import { AppContext } from "../../context/context";
import InvoiceSettingForm from "../../forms/InvoiceSettingForm";
import { get } from "../../services/apiService";
import Navbar from "../Navbar/Navbar";
import "./index.css";
import crose from "../../../src/assets/images/crose.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_ROOT_URL;

function TopHeader(props) {
  const { onLogout, isPublic } = props;
  const { state, updateInvoiceSetting} = useContext(AppContext);

  // Add useLocation hook to get the current path
  const location = useLocation();

  // Define paths where TopHeader should not be shown
  const hiddenPaths = [
    "/login",
    "/verifypin",
    "/other-path",
    "/new-sales-billing",
  ];

  // If the current path matches any of the hidden paths, return null (don't render)
  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }
  console.log("Order List State.......... ",state.orderListState);
  //const { currentUser } = state;
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const shopName = localStorage.getItem("outletname");
  const ownerName = localStorage.getItem("ownername");

  console.log(typeof currentUser?.type);

  const [currency, setCurrency] = useState([]);

  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const currentPage = 1;
  const [open, setOpen] = useState(true);
  const [isVisible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleOpen = () => setShowModal(!showModal);

  const invoiceSettingData = state.invoiceSetting;

  const invoiceSetting = invoiceSettingData
    ? invoiceSettingData
    : {
        outlet_name: "",
        owner_name: "",
        shop_name: "",
        shop_logo: "",
        shop_address: "",
        sign_authority: "",
        name_authority: "",
        currency_id: "",
        category_id: "",
        watermark_text: "",
        watermark_type: "",
      };

  const [logoFile, setLogoFile] = useState();

  const handleChange = ({ target: { files } }) => {
    let tempUploadDetails = [...uploadDetails];

    for (let i = 0; i < files.length; i++) {
      let size = files[i].size / 1024;
      let sizeName = "";

      if (size > 1024) {
        size = (size / 1024).toFixed(2);
        sizeName = size + "MB";
      } else {
        sizeName = size.toFixed(2) + "KB";
      }

      tempUploadDetails.push({
        name: files[i].name,
        size: sizeName,
        percentage: 0,
      });
    }

    setUploadDetails(tempUploadDetails);
    setUploadedFiles(files);

    setLogoFile(URL.createObjectURL(files[0]));
  };
  const toggleVisible = () => {
    if (!isPublic) {
      setVisible(!isVisible);
      setOpen(!open);
    }
  };

  const closeMenu = () => {
    setVisible(false);
    setOpen(false);
  };

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const isPinVerify = localStorage.getItem("isPinVerify");
  //const employee = localStorage.getItem("employee");
  const employee = JSON.parse(localStorage.getItem("employee"));

  useEffect(() => {
    if (!isPublic) {
      if (!token) {
        navigate("/login");
      } else if (token == "false" || token == "") {
        navigate("/login");
      } else if (token != "false" && isPinVerify == "false" && !employee) {
        console.log("topheader");
        navigate("/verifypin");
      }

      if (invoiceSetting.shop_logo) {
        setLogoFile(invoiceSetting.shop_logo);
      }
    }
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [uploadedFilesWatermark, setUploadedFilesWatermark] = useState({});
  const [uploadDetails, setUploadDetails] = useState([]);

  const invoiceSettingDataSave = (values, invoiceSetting) => {
    const { ...data } = values;
    //data.shop_logo = brandLogo.length > 0 ? brandLogo[0] : invoiceSetting && invoiceSetting.shop_logo ? invoiceSetting.shop_logo : null;
    //data.shop_logo = brandLogo.length > 0 ? brandLogo[0] : invoiceSetting && invoiceSetting.shop_logo ? invoiceSetting.shop_logo : null;
    loadingCallback(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}save-invoice-settings`, data, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        loadingCallback(false);
        if (response.data.success) {
          getInvoiceSetting();
          setLogoFile(data.shop_logo);
          if (data.watermark_type == "Logo") {
            setUploadedFilesWatermark(data.watermark_text);
          }
          setShowModal(false);
        } else {
          setLogoFile("");
        }
      })
      .catch((error) => {
        console.log(error);
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
      });
  };

  const getInvoiceSetting = () => {
    loadingCallback(true);
    get("get-invoice-settings", token)
      .then((response) => {
        if (response.success) {
          updateInvoiceSetting(response.data);
        }
        setLogoFile(response.data.shop_logo);
        loadingCallback(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function handleSubmitInvoiceSetting(values, invoiceSetting) {
    let imageFileData = uploadDetails;
    if (values.watermark_type == "text") {
      imageFileData = uploadDetails.filter(
        (item) => item.input_name != "watermark_text"
      );
    }
    console.log(imageFileData);
    loadingCallback(true);

    uploadFileMultipleInput(
      imageFileData,
      (shopLogo) => {
        const updatedFormData = { ...values };
        shopLogo.forEach((item) => {
          updatedFormData[item.input_name] = item.path;
        });
        // Success callback
        invoiceSettingDataSave(updatedFormData, invoiceSetting);
      },
      (error) => {
        // Error callback
        console.log(error);
        loadingCallback(false);
      },
      (progressDetails) => {
        // Progress callback, update uploadDetails here
        setUploadDetails(progressDetails);
      }
    );
  }

  const handleBlockedNavigation = (e) => {
    if (state.orderListState && state.orderListState.length > 0) {
      e.preventDefault(); // Stop the navigation
      Swal.fire({
        title: "Cannot navigate",
        text: "Products are present in the cart. You cannot navigate away.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <div className="fixed md:static bg-[#EBF1FF] h-[7.3rem] pt-[30px] md:pt-0 top-0 w-full left-[50%] translate-x-[-50%] md:translate-x-0  z-[9999]">
        <div className="topheader">
          <div className="setting-notification hidden md:flex overflow-x-auto gap-2 items-center justify-center">
            {(currentUser?.type == "3"
              ? [
                  { path: "/vendor-list", label: "Vendor List" },
                  { path: "/customer-list", label: "Customer List" },
                  { path: "/imeireport-page", label: "IMEI/Serial History" },
                  {
                    path: "/monthly-sales-day-counting-report",
                    label: "Sales Report",
                  },
                  {
                    path: "/monthly-purchase-report",
                    label: "Purchase Report",
                  },
                  {
                    path: "/expense-type-wise-report",
                    label: "Expense Reoport",
                  },
                  {
                    path: "/cashbook-details-history",
                    label: "CB Details Report",
                  },
                  {
                    path: "/billing",
                    label: "POS",
                    state: { online: false },
                    style:
                      "bg-gradient-to-br from-blue-500 to-blue-700 text-white",
                  },
                  {
                    path: "/billing",
                    label: "Online Sale Billing",
                    state: { online: true },
                  },
                  {
                    path: "/purchase-billing",
                    label: "Purchase",
                    // style:
                    //   "bg-gradient-to-br from-green-500 to-green-700 text-white",
                  },
                ]
                : currentUser?.type == "4" ?
                [
                  {
                    path: "/monthly-sales-day-counting-report",
                    label: "Sales Report",
                  },
                  {
                    path: "/expenselist",
                    label: "Expense",
                  },
                  {
                    path: "/expense-type-wise-report",
                    label: "Expense Reoport",
                  },
                  {
                    path: "/cashbook-details-history",
                    label: "CB Details Report",
                  },
                  {
                    path: "/store-ledger-report",
                    label: "Store Ledger Report",
                  },
                  { path: "/fund-transfer", label: "Fund Transfer" },
                  { path: "/hold-invoice-list", label: "Hold", style: "bg-gradient-to-br from-purple-400 to-purple-600 text-white" },
                  {
                    path: "/billing",
                    label: "POS",
                    state: { online: false },
                    style:
                      "bg-gradient-to-br from-blue-500 to-blue-700 text-white",
                  },
                  {
                    path: "/purchase-billing",
                    label: "Purchase",
                    style:
                      currentUser?.id === 129
                        ? "bg-gradient-to-br from-green-500 to-green-700 text-white w-[80px]"
                        : "bg-gradient-to-br from-green-500 to-green-700 text-white",
                  },
                ]
              : [
                  {
                    path: "/monthly-sales-day-counting-report",
                    label: "Sales Report",
                  },
                  {
                    path: "/expenselist",
                    label: "Expense",
                  },
                  {
                    path: "/expense-type-wise-report",
                    label: "Expense Reoport",
                  },
                  {
                    path: "/cashbook-details-history",
                    label: "CB Details Report",
                  },
                  {
                    path: "/cashbook-summary-report",
                    label: "CB Summary Report",
                  },
                  {
                    path: "/store-ledger-report",
                    label: "Store Ledger Report",
                  },
                  { path: "/fund-transfer", label: "Fund Transfer" },
                  {
                    path: "/billing",
                    label: "POS",
                    state: { online: false },
                    style:
                      "bg-gradient-to-br from-blue-500 to-blue-700 text-white",
                  },
                  {
                    path: "/purchase-billing",
                    label: "Purchase",
                    style:
                      currentUser?.id === 129
                        ? "bg-gradient-to-br from-green-500 to-green-700 text-white w-[80px]"
                        : "bg-gradient-to-br from-green-500 to-green-700 text-white",
                  },
                ]
            ).map((item, index) => (
              <Link key={index} to={item.path} state={item.state}>
                <div
                  onClick={handleBlockedNavigation}
                  className={`flex items-center justify-center w-[110px] h-[45px] rounded-full p-1 shadow-sm text-center font-nunito transition-all duration-200 hover:translate-x-1 ${
                    item.style ||
                    "bg-white text-gray-800 border hover:bg-[#f0f4ff]"
                  }`}
                >
                  <span className="text-[10px] font-semibold leading-tight break-words">
                    {item.label}
                  </span>
                </div>
              </Link>
            ))}

            {/* Notifications Icon */}
            <div className="notifications-icon flex items-center justify-center w-[60px] h-[60px]">
              <img
                src={`${BASE_URL}/assets/dashboard/notifications.svg`}
                alt="notifications"
              />
              <i
                onClick={toggleVisible}
                className="fi fi-rr-chart-simple-horizontal md:hidden ml-2"
              ></i>
            </div>

            {/* Settings Icon */}
            <Link to={`/settings-v2`}>
              <div onClick={handleBlockedNavigation} className="settings-icon flex items-center justify-center w-[60px] h-[60px]">
                <img
                  src={`${BASE_URL}/assets/dashboard/settings.svg`}
                  alt="settings"
                />
              </div>
            </Link>
          </div>

          {/* For mobile responsiveness */}
          <div className="md:hidden flex items-center justify-between w-full px-4">
            {/* IMEI Serial Report Icon */}
            <Link to="/imeireport-page">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-xs font-bold">IMEI</span>
              </div>
            </Link>

            {/* POS Icon */}
            <Link to="/billing" state={{ online: false }}>
              <div className="w-10 h-10 bg-blue-500 rounded-full text-white flex items-center justify-center">
                <span className="text-xs font-bold">POS</span>
              </div>
            </Link>

            {/* Purchase Icon */}
            <Link to="/purchase-billing">
              <div
                className={`w-10 h-10 ${
                  currentUser?.id === 129
                    ? "w-[50px]" // custom width for user id 129
                    : "w-10"
                } bg-green-500 rounded-full text-white flex items-center justify-center`}
              >
                <span className="text-xs font-bold">PUR</span>
              </div>
            </Link>

            {/* Hamburger / Notification Icon */}
            <div
              onClick={toggleVisible}
              className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center"
            >
              <i className="fi fi-rr-chart-simple-horizontal"></i>
            </div>
          </div>
        </div>
      </div>
      {isVisible && (
        <div>
          <Navbar onLogout={onLogout} closeMenu={closeMenu}></Navbar>
        </div>
      )}
      {loading && (
        <div className="custom-loader-logo">
          {/* <BeatLoader color={"#123abc"} size={20} /> */}
          <img
            className=""
            src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
            alt="logo"
          />
        </div>
      )}

      {showModal ? (
        <>
          <div>
            {/* The button to open modal */}
            {/* Put this part before </body> tag */}
            <input
              type="checkbox"
              id="modal_Invoice"
              className="modal-toggle"
            />
            <div className="modal">
              <div className="modal-box w-[390px] p-0 bg-white">
                <div className="flex justify-between flex-col md:flex-row px-[18px] pt-[17px] pb-[13px] border-b border-[#D9D9D9]">
                  <h4 className="font-nunito font-semibold text-lg ">
                    Invoice Settings
                  </h4>
                  <div className="modal-action">
                    <label
                      htmlFor="modal_Unit"
                      className="cursor-pointer bg-red-600 text-white rounded-md"
                      onClick={handleOpen}
                    >
                      <img src={crose} width={23} height={20} alt="" />
                    </label>
                  </div>
                </div>
                <div className="px-5 pt-5 pb-[22px]">
                  <InvoiceSettingForm
                    initialValues={{ invoiceSetting }}
                    onSubmit={(values) => {
                      //const { ...updateValues } = values;
                      handleSubmitInvoiceSetting(values, invoiceSetting);
                    }}
                    handleChange={handleChange}
                    file={logoFile}
                    uploadedFilesWatermark={uploadedFilesWatermark}
                    currency={currency}
                    setUploadedFiles={setUploadedFiles}
                    setUploadedFilesWatermark={setUploadedFilesWatermark}
                    uploadDetails={uploadDetails}
                    setUploadDetails={setUploadDetails}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}

export default TopHeader;
